// index.js or main file
import React, { useEffect } from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter, Route, Routes, useLocation } from "react-router-dom";
import Login from "./pages/login/login";
import AdminRedirect from "./adminRedirect/admin";
import Admin from "./admin/admin";
import Home from "./admin/pages/home/home";
import Rules from "./admin/pages/rules/rules";
import { Provider } from "react-redux";
import { store } from "./admin/store";
import LoginPage from "./admin/pages/login/login";
import YogaPoses from "./pages/yogaPoses/YogaPoses";
import TravelGame from "./pages/travelGame/TravelGame";
import TravelLeaderboard from "./pages/travelGame/TravelLeaderboard";
import YogaUpload from "./pages/yogaUpload/YogaUpload";
import YogaGallery from "./pages/yogaGallery/YogaGallery";
import USER from "./pages/dddUI/user";
import CustomizeSpotTheme from "./admin/pages/customize-spot-theme/CustomizeSpotTheme";
import YogaUploads from "./admin/pages/yoga-uploads/YogaUploads";
import { clearThemeBodyBackground } from "./utils/themeBodyBackground";

function usePageBackground() {
  const location = useLocation();
  useEffect(() => {
    const body = document.body;
    body.classList.remove("common-bg");
    if (location.pathname.startsWith("/admin")) {
      clearThemeBodyBackground();
    }
  }, [location]);
}

function App() {
  usePageBackground();

  return (
    <Provider store={store}>
      <Routes>
        <Route path="/admin">
          <Route index element={<Admin><Home /></Admin>} />
          <Route path="rules" element={<Admin><Rules /></Admin>} />
          <Route path="customize-spot" element={<Admin><CustomizeSpotTheme /></Admin>} />
          <Route path="yoga-uploads" element={<Admin><YogaUploads /></Admin>} />
          <Route path="superadmin" element={<LoginPage />} />
        </Route>

        <Route
          path="*"
          element={
            <USER>
              <Routes>
                <Route index element={<Login />} />
                <Route path="/login" element={<Login />} />
                <Route path="/travel-game" element={<TravelGame />} />
                <Route path="/travel-leaderboard" element={<TravelLeaderboard />} />
                <Route path="/yoga-poses" element={<YogaPoses />} />
                <Route path="/yoga-upload" element={<YogaUpload />} />
                <Route path="/yoga-gallery" element={<YogaGallery />} />
                <Route path="/AdminRedirect" element={<AdminRedirect />} />
              </Routes>
            </USER>
          }
        />
      </Routes>
    </Provider>
  );
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <BrowserRouter>
    <App />
  </BrowserRouter>
);

reportWebVitals();
